import React, { useState } from 'react'
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadInduction } from '../DownloadInduction/DownloadInduction';
import { InductionPreviewModal } from './InductionPreviewModal';
import { Label } from 'reactstrap';

export const InductionDownloadOrPreview = ({ induction }) => {
    const { t } = useTranslation();

    const [modal, setModal] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)

    const handlePreview = (file) => {
        setSelectedFile(file);
        setModal(true);
    }

    const isPreviewable = (file) => {
        return file?.type?.split('/')[0] === 'image' ||
            file?.type?.split('/')[0] === 'video' ||
            file?.type === 'application/pdf';
    }

    return (
        <Fragment>
            {modal && selectedFile ? (
                <InductionPreviewModal
                    modal={modal}
                    setModal={setModal}
                    induction={{ ...induction, files: [selectedFile] }}
                />
            ) : null}

            <div>
                <Label className='fw-bold'>{t('common.selected_files')}:</Label>
                <div className="mt-2">
                    {induction?.files && induction.files?.map((file, index) => (
                        <div key={index} className="d-flex align-items-center justify-content-between p-2 border rounded mb-2">
                            <span className="text-truncate me-3">{file.name}</span>
                            <div className="d-flex gap-2">
                                {isPreviewable(file) ? (
                                    <span
                                        style={{ cursor: 'pointer' }}
                                        className='link-primary'
                                        onClick={() => handlePreview(file)}
                                    >
                                        {t('inductions.view_file')} <i className="fa-solid fa-play"></i>
                                    </span>
                                ) : (
                                    <DownloadInduction inductionName={file.name} />
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Fragment>
    )
}
